import React, { Component } from 'react'
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';
import axios from 'axios';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';

let cancelToken;
class Workshops extends Component {

    constructor(props) {
        super(props);
        this.state = {
            list_workshops: {},
            ids_workShops: {},
            qr_code: '',
            statusSubmit: false,
            succesSuscribe: false, 
            errorSuscribe: false, 
            msgError: '',
            buttonSave: true,
        };
    }

    // ES LO PRIMERO QUE SE EJECUTA AL CARGAR LA PAGINA
    componentWillMount() {
        // this.setState({qr_code: this.props.match.params.qr_code});
        this.state.qr_code = this.props.match.params.qr_code;
        cancelToken = axios.CancelToken.source();
        this.handleWorkshops(); 
    }
    
    // Llamar web service para obtener Workshops activos
    handleWorkshops = () => {
        let params = this.state;
        params.token_id = this.props.getTokenId();
        this.props.post(
            "/getWorkshops",
            params,
            (response) => this.handleSuccestWorkshop(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    // Actualizar estado de workshops
    handleSuccestWorkshop = (response) => { 
        this.setState({list_workshops: response}); 
    }

    // Error get promocode
    handleErrorResponse = (codeError, param_uno, param_dos, msgError) => {
        this.setState({errorSuscribe: true});
        this.setState({succesSuscribe: false});
        this.setState({msgError: msgError});
    }

    // CREAR OBJETO PARA MANDARLO COMO PARAMETRO AL WEB SERVICE
    handleSubmit = (event) => {
        event.preventDefault();
        this.handleSuscribe();
    }

    // Llamar web service para registrar workshops a los que se inscribio el cliente
    handleSuscribe = () => {
        let params = this.state;
        params.token_id = this.props.getTokenId();
        this.props.post(
            "/suscribeWorkshops",
            params,
            (response) => this.handleSuccestSuscribe(response),
            (codeError, response_uno, response_dos, msgError) => this.handleErrorResponse(codeError, response_uno, response_dos, msgError),
            cancelToken
        );
    }

    // Actualizar estado de workshops
    handleSuccestSuscribe = (response) => { 
        this.setState({errorSuscribe: false});
        this.setState({succesSuscribe: true});
        this.setState({buttonSave: false});
    }

    // SE CREA ARREGLO CON VALORES DEL FORMULARIO PARA ENVIARLOS AL WEB SERVICE
    handleInputChange = (event) => {
        let objWorkshops = this.state.ids_workShops;
        let workshop_id = event.target.value ; 
        let countCheck = false;
        {event.target.checked ? objWorkshops[workshop_id] = true : objWorkshops[workshop_id] = false}
        this.setState({ids_workShops: objWorkshops});

        if (Object.keys(objWorkshops).length > 0) {
            {Object.keys(this.state.ids_workShops).map((item, i) => (
                this.state.ids_workShops[item] ? countCheck = true : countCheck = false
            ))}
            this.setState({statusSubmit: countCheck});
        }else{
            this.setState({statusSubmit: countCheck});
        }
     }

    // Body
    render() {
        return( 
            <div>
                {this.renderNavbar()}
                <div className="panel panel-default">
                    <div className="page-header"></div>
                    <div className="panel-body container-fluid jumbotron" style={{background:" #f0f0f0ad"}}>
                        <form method="post" onSubmit={this.handleSubmit} >
                            <div className="row">
                                <h4 className="page-header text-primary col-xs-12" style={title}>
                                    <strong>LISTA DE WORKSHOPS SUMMIT 2020</strong>
                                </h4>
                                {this.listWorkshops()}
                                {this.state.succesSuscribe ? this.succesSuscribe() : ""}
                                {this.state.errorSuscribe ? this.errorSuscribe() : ""}
                            </div>
                        </form>
                    </div>
                </div>
                {this.renderFooter()}
            </div>
        );
    }

    listWorkshops = () => {
        let tdList = '';
        if ((this.state.list_workshops).length > 0) {
            tdList = this.state.list_workshops.map((infoWorkshop) =>
                <tr key={infoWorkshop.id} style={{border: '1px solid #D9E4E6'}}>
                    <td style={{maxWidth: '7em', textAlign: 'center', padding: '1em'}}>
                        <input type="checkbox" value = {infoWorkshop.id} name="workshop" onChange={this.handleInputChange} style={{position: 'inherit'}}/>
                    </td>
                    <td style={content}>
                        <b>{infoWorkshop.nombre}</b> (speaker: {infoWorkshop.speaker})
                        <p style={{color: '#36414e', fontSize: 'small'}}>Horario: {infoWorkshop.hora_inicio} - {infoWorkshop.hora_fin}</p>
                    </td>
                </tr>
            );
        } else {
            tdList = <tr><td style={content} colSpan="2">Sin resultados</td></tr>
        }        
        return (
            <table style={tableWorkshops}>
                <tbody>
                    {tdList}
                </tbody>
                <tfoot colSpan="2">
                    <tr style={{border: '1px solid #D9E4E6'}}>
                        <td colSpan="2" style={{maxWidth: '7em', textAlign: 'center', padding: '1em'}}>
                            {!this.state.succesSuscribe && this.state.buttonSave ? <button className="btn btn-primary" type="submit" disabled={!this.state.statusSubmit}> GUARDAR CAMBIOS </button> : ""}
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }

    succesSuscribe = () => {
        return (
            <div className="form-group" style={succes}>
                <center>
                    <p style={{color: 'white',fontSize: '17px',padding:'10px'}}><i className="fa fa-check-square" aria-hidden="true"></i> Suscripción generada con éxito</p>
                </center>
            </div>
        );
    }

    errorSuscribe = (msg) => {
        return (
            <div className="form-group" style={error}>
                <center>
                    <p style={{color: 'white',fontSize: '17px',padding:'10px'}}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> {this.state.msgError}</p>
                </center>
            </div>
        );
    }

    //Section footer 
    renderFooter = () => {
        return(
            <Footer />
        );
    }

    // Section header
    renderNavbar = () => {
        return(
            <Navbar
            handleLanguageChange={this.props.handleLanguageChange}
            lang={this.props.lang} />
        );
    }
}

export default compose(withRouter)(Workshops);

const title = {
    background: '#00bcd4',
    color: '#fff',
    fontSize: 'LARGE',
    fontWeight: '700',
    padding: '16px',
    paddingRight: '56px',
    textAlign: 'center',
    marginTop: 'auto',
    top: '-15px',
};
const tableWorkshops = {
    margin: '1em 0',
    width: '100%',
    overflow: 'hidden',
    background: '#FFF', 
    // color: '#024457',
    color: '#36414e',
    borderRadius: '10px',
    border: '1px solid #167F92',
    fontFamily: 'Arial, sans-serif'
}

const content = {
    wordWrap: 'break-word',
    maxWidth: '7em',
    textAlign: 'left',
    padding: '1em'
}

const succes = {
    background: "#22c40a7d",  
    borderRadius:"5px", 
    fontStyle:"italic",
}

const error = {
    background: "#db920b",  
    borderRadius:"5px", 
    fontStyle:"italic"
}


// WEBPACK FOOTER //
// ./src/guest/summit/Workshops.js